import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './authentication/login/login.component';
import { AccesInterditComponent } from './authentication/acces-interdit/acces-interdit.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ConsultationComponent } from './features/consultation/consultation.component';
import { PortailHomeComponent } from './features/portail-home/portail-home.component';
import { HomeComponent } from './features/home-page/home.component';
import { RecrutementComponent } from './features/recrutement/recrutement.component';
import { RenouvellementComponent } from './features/renouvellement/renouvellement.component';
import { ValidationDemandesComponent } from './features/validation-demandes/validation-demandes.component';
import { DemandeAvisListComponent } from './features/demande-avis-list/demande-avis-list.component';
import { Role } from '@models/enums';
import { CanDeactivateGuard } from './core/guard/can-deactivate.guard';
import { AdministrationComponent } from './features/administration/administration.component';
import { GestionDelegationsComponent } from './features/administration/gestion-delegations/gestion-delegations.component';
import { ConsultationFinContratComponent } from './features/consultation-fin-contrat/consultation-fin-contrat.component';
import { ConsultationAnnuairePosteComponent } from './features/consultation-annuaire-poste/consultation-annuaire-poste.component';
import { SuivieImportsComponent } from './features/administration/suivie-imports/suivie-imports.component';
import { ParametresComponent } from './features/administration/parametres/parametres.component';
import { ListePostesComponent } from './features/administration/liste-postes/liste-postes.component';
import { GestionServicesComponent } from './features/administration/gestion-services/gestion-services.component';
import { GestionDirectionsComponent } from './features/administration/gestion-directions/gestion-directions.component';

export const routes: Routes = [
  {
    path: 'pama',
    component: LayoutComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'consultation',
        component: ConsultationComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR] }
      },
      {
        path: 'recrutement',
        component: RecrutementComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR] }
      },
      {
        path: 'renouvellement',
        component: RenouvellementComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR] }
      },
      {
        path: 'validation-demandes',
        component: ValidationDemandesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR] }
      },
      {
        path: 'demande-avis-list',
        component: DemandeAvisListComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER] }
      },
      {
        path: 'administration',
        component: AdministrationComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'administration/gestion-delegations',
        component: GestionDelegationsComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'consultation-fin-contrats',
        component: ConsultationFinContratComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER] }
      },
      {
        path: 'consultation-annuaire-poste',
        component: ConsultationAnnuairePosteComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER] }
      },
      {
        path: 'administration/suivi-imports',
        component: SuivieImportsComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'administration/parametres_de_configurations',
        component: ParametresComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'administration/liste-postes',
        component: ListePostesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'administration/gestion-services',
        component: GestionServicesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      },
      {
        path: 'administration/gestion-directions',
        component: GestionDirectionsComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.PAMA_ADMIN] }
      }
    ]
  },
  {
    path: 'acces-interdit',
    component: AccesInterditComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomeComponent
      }
    ]
  }
];
